// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_a4-0";
export var orangeButton = "_a4-1";